import React, { Component }                 from "react";
import { Container,Row,Col,Button,Navbar,NavbarBrand,Input }                          from "reactstrap"

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./pages/general/App.css";
import "./pages/general/Tabs.css";
import { BrowserRouter as Router, Route, }  from "react-router-dom";
import HeaderPage                           from "./pages/general/header.page";
import HeaderDirectorPage                   from "./pages/general/header.director.page";
import HeaderPointSalePage                  from "./pages/general/header.pointsale.page";
import HeaderContadorPage                   from "./pages/general/header.contador.page";
import TabsPage                             from "./pages/general/tabs.page";
import RedirectorPage                       from "./pages/general/redirector.page";
/**
* LOGIN SECTION
**/
import LoginPage                            from "./pages/loginPage/Login.page";
/**
* Section Administrator
**/
//Progreso
import MainProgresoPage                     from "./pages/adminPage/progreso/main.page";
import UpdateCostosPage                     from "./pages/adminPage/progreso/update.costos.page";
import SucursalDirePage                     from "./pages/adminPage/sucursal/sucursal.page";
import TableroDirePage                      from "./pages/adminPage/tablero/main.page";
//Registros
import RegisterGastosPage                   from "./pages/registrosPage/gastos.page";
import RegisterVentaPage                    from "./pages/registrosPage/ventas.page";
import UploadReportsPage                    from "./pages/registrosPage/subir.reportes.page";
//Clientes
import FacturacionPage                      from "./pages/clientesPage/facturacion.page";

//Register control de productos
import RegisterControlProductos             from "./pages/registrosPage/control.productos.page";

//CAJERO
import ViewCajeroPage                       from "./pages/cajeroPage/cajero.page";

//RH
import RHContador                           from "./pages/rhPage/contador.page";


import socketIOClient                       from "socket.io-client";
import moment from 'moment'

const ENDPOINT = "https://wsoft.com.mx:3010";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      debug: 0,
      appConnected: false,
      updateApp: {stat: false, text: '', countFileLocalUpdated: 0, onlySync: false, },
      signedIn: [],
      socket: socketIOClient(ENDPOINT),
      typeHeader: 1,
      viewApp: '__redirector',
      tabsArray: [
        { index: 1, active: 1, img: 'img/pos/tab1.png', name: '' },
        { index: 2, active: 0, img: 'img/pos/tab3.png', name: '' },
        { index: 3, active: 0, img: 'img/pos/tab2.png', name: '' },
        { index: 4, active: 0, img: 'img/pos/tab4.png', name: '' },
      ],
      sectionItems: {section:'index',idItem:'', indexItem: -1},
      contentItems : [
        { id:'1', nombre: 'Chatarra', precio: '10.00' },
        { id:'2', nombre: 'Aluminio', precio: '10.00' },
        { id:'3', nombre: 'Cobre', precio: '8.00' },
        { id:'4', nombre: 'Inox', precio: '10.00' },
        { id:'5', nombre: 'Inox', precio: '10.00' },
        { id:'6', nombre: 'Inox', precio: '10.00' },
        { id:'7', nombre: 'Inox', precio: '10.00' },
      ],
      contentSubitems: [
        {
          id: '1',
          items: [
            {id:'1',nombre:'Fierro',precio:'10.00'},
            {id:'2',nombre:'Lámina',precio:'8.00'},
            {id:'3',nombre:'Otros',precio:'10.00'},
          ]
        },
        {
          id: '2',
          items: [
            {id:'1',nombre:'Fierro2',precio:'10.00'},
            {id:'2',nombre:'Lámin2',precio:'8.00'},
            {id:'3',nombre:'Otro2',precio:'10.00'},
          ]
        },

      ],
      data: {},
      //Admin section Progreso
      tabProgresoActive: 1,
      //Ejecutivo section switch
      renderView: 'nuevaCompra',
      // renderView: 'general',
      // renderView: 'altas',
      RTDirector: { text: '', },
      url_facturacion: localStorage.url_facturacion,
      printerActive: localStorage.printerActive === '1' ? 1 : 0,

      dateDire: moment().format('YYYY-MM-DD'),
      arrSucursalSelected: {e: -1, t: {}},

      isMobile: true,
    }

    this.nodeListenByTypeUser  = this.nodeListenByTypeUser.bind(this)
    this.nodeListenDisconnect  = this.nodeListenDisconnect.bind(this)
    this.RTSocketDirector      = this.RTSocketDirector.bind(this)
    this.RTSocketEjecutivo     = this.RTSocketEjecutivo.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    const { isMobile } = this.state

    this.setState({ width: window.innerWidth, height: window.innerHeight });
    if(window.innerWidth <= 600 && !isMobile) {
      this.setState({ isMobile: true, })
      // console.log('cambiando vista móvil')
    } else if(window.innerWidth > 600 && isMobile) {
      this.setState({ isMobile: false, })
      // console.log('cambiando vista web')
    }
  }

  getConnectionSocket() {
    this.state.socket.on("connect", this.nodeListenByTypeUser)
    this.state.socket.on("disconnect", this.nodeListenDisconnect)
  }

  nodeListenByTypeUser() {
    const { viewApp } = this.state
    this.setState({ appConnected: true, })

    if(viewApp === '__redirector') {
      //Reintentamos hasta encontrar el viewApp
      setTimeout(() => {this.nodeListenByTypeUser()}, 100)
    } else {
      if(viewApp === 'director') this.state.socket.on("__directorReceive", this.RTSocketDirector);
      if(viewApp === 'ejecutivo') {
        this.state.socket.on("__cajeroReceive", this.RTSocketEjecutivo);
        setTimeout(() => {
          //Service autosyncRegs
          this.setState({ updateApp: {stat: true, text: 'Iniciando actualización...', countFileLocalUpdated: 0, onlySync: true, }, })
          this.makeUpdateEjecutivoApp(1)
        }, 1000)
      } else if(viewApp === 'control_sucursal') {
        //Vista Araceli
        this.setState({
          renderView: 'general',
        })
      }
    }
  }

  nodeListenDisconnect() {
    this.setState({ appConnected: false, })
  }

  RTSocketDirector(data) {
    const { substrace, signedIn, opt, pos } = data

    if( substrace === 'updateVentaPoS' && (pos && pos === 'multiservicios') ) {
      const { apellidos, nombre, sucursal, } = signedIn
      if(opt === 1) {
        //Nueva compra en proceso...

        this.setState({
          RTDirector: {
            text: `Se está realizando un registro...`,
          }
        })
      } else if(opt === 2) {
        //Compra realizada, recargando

        this.setState({ RTDirector: {
          text: `Se concluyó un registro.`,
        }})
        setTimeout(() => { this.setState({ RTDirector: { text: `` } })}, 3000)
        if(typeof this.child === 'object') {
          this.child.state.__getProgreso()
        }
      } else if(opt === 0) {
        //Cancelación de compra
        this.setState({ RTDirector: {
          text: `Se CANCELÓ un registro.`,
        }})
        setTimeout(() => { this.setState({ RTDirector: { text: `` } })}, 3000)
      }
    }

  }

  RTSocketEjecutivo(data) {
    const { signedIn } = this.state
    const { substrace, suc, } = data

    if(substrace === 'updatePoS') {
      if(suc === 'all' || suc === signedIn.id_sucursal) {
        //Mostrar cargando...
        this.setState({ updateApp: {stat: true, text: 'Iniciando actualización...', countFileLocalUpdated: 0, onlySync: false, }, })
        setTimeout(() => {
          this.makeUpdateEjecutivoApp(1)
        }, 300)
      }
    } else if(substrace === 'updateCost') {
      //Update arrayCosts
      this.setState({
        updateApp: {stat: true, text: 'Actualizando costos...', countFileLocalUpdated: 0, onlySync: true, }
      })
      this.childEjecutivo.state.__updateCosts()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.getConnectionSocket()

    if(typeof localStorage.printerActive === 'undefined') {
      this.setState({ printerActive: 1, })
    }

    let param = window.location.search;
    if( param.indexOf('?debug=1') !== -1 )
      this.setState({ debug: 1, });
  }

  render() {
    const { viewApp } = this.state

    return (
      <div className={`${viewApp === 'login' ? 'ws__login_view' : ''}`} style={{
          background: (viewApp === 'director' ? '#fff' : '#f2f2f2'),
          /*height: '100%',*/ 
          paddingTop: ((viewApp === 'director'|| viewApp === 'facturacion' || viewApp === 'ejecutivo') ? 0 : 50), paddingBottom: ((viewApp==='ejecutivo') ? 0 : 10),height: ((viewApp==='ejecutivo') ? '100%' : 'auto' ) }}>
        <Router>
          { viewApp === '__redirector' ?
            <Route exact>
              <RedirectorPage nodeListener={ () => this.nodeListenByTypeUser} initState={ this.state } initsetState={ (param, callback) => this.setState(param, callback)} />
            </Route>
          : null }

          <Route exact path="/login">
            <LoginPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
          </Route>

          { viewApp === 'director' ? this.makeRenderDirector() : null }
          { viewApp === 'ejecutivo' ? <ViewCajeroPage initState={ this.state } initsetState={ (param, callback) => this.setState(param, callback)} /> : null }
        </Router>
      </div>
    );
  }

  makeRenderFacturacion() {
    return (
      <>
        {/* Header */}

          <Route exact path="/">
            <FacturacionPage
              initState={ this.state }
              initsetState={ (param) => this.setState(param)}
              onRef={ref => (this.child = ref)} 
            />
          </Route>
      </>
    )
  }

  makeRenderDirector() {
    const { tabProgresoActive, tabsArray } = this.state

    let indexActiveDire = -1
    tabsArray.map((t) => { if(t.active === 1) { indexActiveDire = t.index } })
    // indexActiveDire = 3

    return (
      <>
        {/* Header */}
        <HeaderDirectorPage initState={ this.state } initsetState={ (param) => this.setState(param) } />

          <Route exact path="/">
            { indexActiveDire === 1 ?
              <MainProgresoPage
                initState={ this.state }
                initsetState={ (param) => this.setState(param)}
                onRef={ref => (this.child = ref)} 
              /> : null
            }

            { indexActiveDire === 2 ?
              <SucursalDirePage
                initState={ this.state }
                initsetState={ (param) => this.setState(param)}
                onRef={ref => (this.child = ref)} 
              /> : null
            }

            { indexActiveDire === 3 ?
              <TableroDirePage
                initState={ this.state }
                initsetState={ (param) => this.setState(param)}
                onRef={ref => (this.child = ref)} 
              /> : null
            }

            
          </Route>

          <Route exact path="/registra-gastos">
            <RegisterGastosPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
          </Route>

          <Route exact path="/actualiza-costos">
            <UpdateCostosPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
          </Route>
        {/* Tabs */}
        <TabsPage initState={ this.state } initsetState={ (param) => this.setState(param) } />
      </>
    )
  }

  makeRenderEjecutivo() {
    const { renderView } = this.state

    return (
      <div style={{ background: (renderView === 'nuevaCompra' ? '#f3f3f3' : '#fff'), }}>
        <Router>
          {/* Header */}
          <HeaderPointSalePage initState={ this.state } initsetState={ (param) => this.setState(param) } />

            <Route type={0} exact path="/" initState={ this.state }>
              <RegisterVentaPage
                onRef={refEj => (this.childEjecutivo = refEj)}
                initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
            <Route exact path="/registra-gastos">
              <RegisterGastosPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
            
          {/* Tabs */}
          {/*<TabsPage initState={ this.state } initsetState={ (param) => this.setState(param) } />*/}
        </Router>
      </div>
    )
  }

  makeRenderControlSucursal() {
    const { renderView } = this.state

    return (
      <div style={{ background: (renderView === 'nuevaCompra' ? '#f3f3f3' : '#fff'), }}>
        <Router>
          {/* Header */}
          <HeaderPointSalePage initState={ this.state } initsetState={ (param) => this.setState(param) } />

            <Route type={0} exact path="/" initState={ this.state }>
              <RegisterVentaPage
                onRef={refEj => (this.childEjecutivo = refEj)}
                initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
            <Route exact path="/registra-gastos">
              <RegisterGastosPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
            
          {/* Tabs */}
          {/*<TabsPage initState={ this.state } initsetState={ (param) => this.setState(param) } />*/}
        </Router>
      </div>
    )
  }

  makeRenderControlProductos() {
    const { renderView } = this.state

    return (
      <div style={{ background: '#f3f3f3', }}>
        <Router>
          {/* Header */}
          <HeaderPointSalePage initState={ this.state } initsetState={ (param) => this.setState(param) } />
            <Route type={0} exact path="/" initState={ this.state }>
              <RegisterControlProductos
                onRef={refEj => (this.childEjecutivo = refEj)}
                initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
          {/* Tabs */}
          {/*<TabsPage initState={ this.state } initsetState={ (param) => this.setState(param) } />*/}
        </Router>
      </div>
    )
  }

  makeRenderRHContable() {
    const { renderView } = this.state

    return (
      <div style={{ background: '#f3f3f3', }}>
        <Router>
          {/* Header */}
          <HeaderContadorPage initState={ this.state } initsetState={ (param) => this.setState(param) } />
            <Route type={0} exact path="/" initState={ this.state }>
              <RHContador
                onRef={refEj => (this.childEjecutivo = refEj)}
                initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
          {/* Tabs */}
          {/*<TabsPage initState={ this.state } initsetState={ (param) => this.setState(param) } />*/}
        </Router>
      </div>
    )
  }

  makeUpdateEjecutivoApp(opt) {
    let { countFileLocalUpdated, onlySync, } = this.state.updateApp
    if(opt === 1) {
      //Si es 1 verifica y pide un doc a sincronizar...
      //Paso 1 sincronizar todas las ventas sin enviar
      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=syncVentasLocal", this.headersPOST({  }))
      .then(response => response.json())
      .then((response) => {
        countFileLocalUpdated = (countFileLocalUpdated + 1)
        this.setState({ updateApp: {stat: true, text: `Sicronizando registros sin enviar #${(countFileLocalUpdated)}...`, countFileLocalUpdated }, })

        //Si ya no hay documentos por sincronizar comenzamos a actualizar...
        if(response.can === 0) {
          if(onlySync) {
            this.setState({ updateApp: {stat: false, text: '', countFileLocalUpdated: 0, onlySync: true, }, })
          } else {
            this.makeUpdateEjecutivoApp(2)
          }
        } else {
          if(response.type === 'venta') {
            fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=setRegisterNewVenta", this.headersPOST({ ...response.data, }))
            .then(response0 => response0.json())
            .then((response0) => {
              if(response0.status === 'ok') {
                //Delete local file
                fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRemoveLocalVenta", this.headersPOST({file: response.file}))
                .then(response1 => response1.json())
                .then((response1) => {
                  setTimeout(() => { this.makeUpdateEjecutivoApp(1) }, 1000)
                }).catch((error) => { /*alert('Ocurrió un error al intentar sincronizar las ventas. Contacta a tu administrador.'); window.location.reload();*/ })
              }
            }).catch((error) => { /*alert('Ocurrió un error al intentar sincronizar las ventas. Contacta a tu administrador.'); window.location.reload();*/ })
          } else if(response.type === 'corte') {
            fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=setRegisterNewCorte", this.headersPOST({ ...response.data, }))
            .then(response0 => response0.json())
            .then((response0) => {
              fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRemoveLocalVenta", this.headersPOST({file: response.file}))
              .then(response1 => response1.json())
              .then((response1) => {
                setTimeout(() => { this.makeUpdateEjecutivoApp(1) }, 1000)
              }).catch((error) => { /*alert('Ocurrió un error al intentar sincronizar las ventas. Contacta a tu administrador.'); window.location.reload();*/ })
            }).catch((error) => console.info(error));
          }
        }
      })
      .catch((error) => {
        // alert('Ocurrió un error al intentar sincronizar las ventas. Contacta a tu administrador.')
        this.setState({ updateApp: {stat: false, text: '', countFileLocalUpdated: 0, onlySync: true, }, })
        // window.location.reload()
      })

    } else if(opt === 2) {
      //Si es dos manda actualizar la paquetería

      //Paso 2 actualizar
      this.setState({ updateApp: {stat: true, text: 'Actualizando sistema...',}, })

      //Paso 3 recargar sitio para aplicar cambios

      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=updatePoS", {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({}),
      })
      .then(response => response.json())
      .then((response) => {
        this.setState({ updateApp: {stat: true, text: 'Actualización realizada con éxito. Recargando...',}, })
        alert( 'Actualización realizada con éxito. Recargando...' )
        window.location.reload()
      })

    }
  }

  /**
  * UPLOAD ACCOUNT
  **/
  makeRenderUpload() {
    return (
      <div style={{ background: '#fff', height: '100%', paddingTop: '50px', }}>
        <Router>
          {/* Header */}
          <HeaderPage type={0} initState={ this.state } initsetState={ (param) => this.setState(param) } />
            <Route exact path="/">
              <UploadReportsPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
          {/* Tabs */}
        </Router>
      </div>
    );
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

}

export default App;




